import React from 'react';
import { CheckCircle } from 'lucide-react';

export const WannBrauchen = () => {
  const beispiele = [
    'Bei sichtbaren Schäden ab ca. 750€ Schadenhöhe',
    'Wenn Wertminderung des Fahrzeugs zu erwarten ist',
    'Bei Nutzungsausfall (z.B. Sie benötigen ein Ersatzfahrzeug)',
    'Zur Beweissicherung bei komplexen Unfallhergängen',
    'Wenn die Versicherung eine objektive Schadenbewertung verlangt',
    'Bei Totalschäden zur Ermittlung des Wiederbeschaffungswerts'
  ];

  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Orientierung
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wann brauche ich ein Unfallgutachten?
          </h2>
          
          {/* AI-Kurzantwort-Box */}
          <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-xl p-5 mb-8 max-w-3xl mx-auto text-left">
            <p className="text-sm font-semibold text-brand-green-dark mb-2">Kurz zusammengefasst:</p>
            <p className="text-gray-700 leading-relaxed text-[15px]">
              Ein Unfallgutachten ist sinnvoll, wenn der Schaden über einen Bagatellschaden hinausgeht oder eine objektive Bewertung zur Durchsetzung von Ansprüchen erforderlich ist.
            </p>
          </div>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Ein Unfallgutachten ist in folgenden Fällen empfehlenswert
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {beispiele.map((beispiel, index) => (
            <div key={index} className="bg-white border border-gray-100 rounded-2xl p-6 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15">
                    <CheckCircle className="w-5 h-5 text-brand-green" />
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed text-[15px] pt-1.5">{beispiel}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-gray-500 italic">
            Hinweis: Die Notwendigkeit eines Gutachtens ist einzelfallabhängig. Diese Aufstellung stellt keine Rechtsberatung dar.
          </p>
        </div>
      </div>
    </section>
  );
};